<template>
    <div>
        <b-modal :active.sync="isComponentModalActive" has-modal-card full-screen>
            <div class="modal-card">
                <section class="modal-card-body">
                    <TemplateLoadStatus />
                    <b-button icon-left="plus" type="is-success" @click="addEditTemplate('i', null)">Add New</b-button>
                    <hr>
                    <b-table :data="templateCatalogue" :loading="$store.state.mytemplateTxt.loading"
                             bordered striped narrowed hoverable mobile-cards>
                        <b-table-column label="Edit" v-slot="props">
                            <b-button icon-left="pencil" type="is-warning" @click="addEditTemplate('u', props.row.id)">Edit</b-button>
                        </b-table-column>
                        <b-table-column label="Title" v-slot="props">{{ props.row.title }}</b-table-column>
                        <b-table-column label="Delete" v-slot="props">
                            <b-button icon-left="delete" type="is-danger" @click="deleteTemplate(props.row.id)">Delete</b-button>
                        </b-table-column>
                        <template slot="empty">
                            <p v-if="$store.state.mytemplateTxt.loaded">Nothing here.</p>
                        </template>
                    </b-table>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-danger" icon-left="close" @click="close">Close</b-button>
                </footer>
            </div>
        </b-modal>
        <AddEditTemplate v-if="isModalAddEditActive" :paramAddEditTemplate="paramAddEditTemplate"
                         @close="closeAddEdit" @closeAddEditModalWithChange="closeAddEditModalWithChange" />
    </div>
</template>
<script>
import axios from 'axios'
import { getBaseURLforBackEnd, getConfigAxios } from '@/utils.js'
import templateCatalogue from '@/mixins/templateCatalogue'
import AddEditTemplate from './AddEditTemplate'
export default {
    name: 'ManageMyTemplate',
    mixins: [templateCatalogue],
    components: { AddEditTemplate },
    data() {
        return { isComponentModalActive: false, isModalAddEditActive: false,
            paramAddEditTemplate: { mode: '', id: null } }
    },
    methods: {
        loadMytemplate() { return this.ensureTemplateList() },
        addEditTemplate(mode, id) { this.paramAddEditTemplate = { mode, id }; this.isModalAddEditActive = true },
        closeAddEdit() { this.isModalAddEditActive = false },
        closeAddEditModalWithChange() { this.isModalAddEditActive = false; this.loadMytemplate() },
        close() { this.isComponentModalActive = false; this.$emit('close') },
        deleteTemplate(id) {
            this.$buefy.dialog.confirm({
                title: 'Deleting Template', message: 'Delete this template?',
                confirmText: 'Delete', type: 'is-danger', hasIcon: true,
                onConfirm: async () => {
                    const token = localStorage.getItem('access_token')
                    const config = getConfigAxios()
                    try {
                        await axios.post(`${getBaseURLforBackEnd()}/api/deletetemplatenonautomate`, { id },
                            { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } })
                        if (token !== localStorage.getItem('access_token')) return
                        await this.$store.dispatch('mytemplateTxt/invalidate')
                        await this.loadMytemplate()
                    } catch (error) {
                        this.$buefy.toast.open({ message: 'Unable to delete template. Please retry.', type: 'is-danger' })
                    }
                }
            })
        }
    }
}
</script>
